import {Telephone} from 'models'

export enum UserVerificationStatus {
    Unregistered = 1,
    NotVerified = 2,
    Verified = 3
}

export class Booking {
    bookingId: number;
    summary: string;
    shortSummary: string;
    calendarSummary: string;
    checkIn: Date;
    checkOut: Date;
    accommodationId: number;
    guestUserId: string;

    guestFirstName: string;
    guestLastName: string;
    guestEmail: string;

    guestTelephone: string;
    telephone: Telephone;

    guestStatus: UserVerificationStatus;

    constructor(props?: { [key in keyof Booking]?: Booking[key] }) {
        this.telephone = new Telephone();
        Object.assign(this, props);
    }
}

export class BookingValidation {
    message: string;
    cost: number;
    isValid: boolean;
    verificationNeeded: boolean;
}

export class BookingSummary {
    bookingSummaryResult: BookingSummaryResult[];
    approved: number = 0;
    notApproved: number = 0;
    cancelled: number = 0;
    rejected: number = 0;
    total: number = 0;
}

export class BookingSummaryResult {
    bookingViewId: number;
    bookingId: number;
    verificationUrl: string;
    friendlyName: string;
    addressLine1: string;
    postcode: string;
    guestName: string;
    guestEmail: string;
    bothNames: string;
    checkIn: Date;
    checkOut: Date;
    showVerificationLink: boolean;
    progress: string;
    progressJson: string;
    guestBookingStatus: string;
    showCancellationButton: boolean;
    hasSignedContract: boolean;
    contractVerificationId: number;
}

export class BookingPhotoUpload {
    bookingId: number;
    imageType: BookingImageType;
}

export enum BookingImageType {
    CheckIn = 1,
    CheckOut = 2,
    Other = 3
}

export class BookingCancellation {
    id: number;
}

export class BookingStatus {
    static cancelled = "Cancelled";
    static notApproved = "Not Approved";
    static approved = "Approved";
    static rejected = "Rejected";
}